"use client";

import { cn } from "../utils/classnames";
import { CarouselNext, CarouselPrevious, useCarousel } from "./Carousel";

export type ReviewCarouselVariant = "on-dark" | "on-light";

export const ReviewCarouselTitle = ({
  title,
  reviewsLength,
  variant = "on-dark",
}: {
  title: string;
  reviewsLength: number;
  variant?: ReviewCarouselVariant;
}) => {
  const { canScrollPrev, canScrollNext } = useCarousel();

  const showArrows = canScrollPrev || canScrollNext;

  return (
    <div className="mx-4 mb-8 flex items-start justify-between sm:mx-10 lg:mx-[72px] 2xl:mx-[152px]">
      <h3
        className={cn(
          "font-bold font-jakarta text-xl md:text-1xl",
          variant === "on-light"
            ? "text-new-beginnings-base"
            : "text-support-base",
        )}
      >
        {title}
      </h3>
      {reviewsLength > 1 && showArrows && (
        <div className="my-auto hidden items-center gap-4 md:flex">
          <CarouselPrevious className={"h-10 w-10"} />
          <CarouselNext className={"h-10 w-10"} />
        </div>
      )}
    </div>
  );
};
